import { SECTIONS } from '../utils';

export function SubNav({ active, setActive }: { active: string; setActive: (id: string) => void }) {
  return (
    <div className="subnav">
      <div className="subnav-inner">
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            className={active === s.id ? 'active' : ''}
            onClick={() => {
              setActive(s.id);
              const el = document.getElementById(s.id);
              if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
            }}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}
